import React from 'react';
import { styled } from '@mui/material/styles';
import VisibilityIcon from '@mui/icons-material/Visibility';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';
import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';

const StyledIconButton = styled(IconButton, {
  shouldForwardProp: prop => prop !== 'indeterminate'
})(({ indeterminate }) => ({
  ...(indeterminate && { color: 'rgba(0, 0, 0, 0.18)' })
}));

export default function StatusIcon(props) {
  const { checked, indeterminate, onClick, title } = props;
  return (
    <Tooltip title={title}>
      <StyledIconButton
        onClick={onClick}
        aria-label={title}
        size="small"
        indeterminate={indeterminate}
      >
        {checked ? <VisibilityIcon /> : <VisibilityOffIcon />}
      </StyledIconButton>
    </Tooltip>
  );
}
